import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { REGULAR_POST_TYPE } from '../../constants/FeedConstants'
import { FeedTileResolver } from '../Feed/FeedTileResolver'

const Container = styled.div`
  margin: 80px auto 40px;
  max-width: 1197px;
  padding: 0 0;

  @media (max-width: 800px) {
    margin: 40px 0 30px;
    padding: 0 0 100px;
    max-width: none;
  }
`

const Title = styled.div`
  text-align: center;
  margin-bottom: 40px;

  @media (max-width: 800px) {
    margin-bottom: 30px;
  }
`

const TitleText = styled.span`
  color: black;
  font-size: 24px;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-weight: 700;
  letter-spacing: 0.24px;
  word-wrap: break-word;

  @media (max-width: 800px) {
    font-size: 20px;
    letter-spacing: 0.2px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    letter-spacing: 0.18px;
  }
`

const UserNameText = styled.span`
  color: #ff5e6d;
  font-size: 24px;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-weight: 700;
  letter-spacing: 0.24px;
  word-wrap: break-word;

  @media (max-width: 800px) {
    font-size: 20px;
    letter-spacing: 0.2px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    letter-spacing: 0.18px;
  }
`

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
  max-width: 100%;

  @media (max-width: 800px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 479px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    padding: 0 12px;
  }
`

const PostContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const PostTile = styled.div`
  aspect-ratio: 1/1;
  height: auto;
  width: auto;
`

export const MoreDesignsByUser = ({ userName, userDesigns = [] }) => {
  const { likes: likesObj } = useSelector(state => state.like)
  const { savedIds } = useSelector(state => state.saveInspiration)

  if (!userName || !userDesigns || userDesigns.length === 0) {
    return null
  }

  // Show max 8 designs (2 rows x 4 columns on desktop)
  const displayedDesigns = userDesigns.slice(0, 8)

  // Convert userDesigns to the format expected by FeedTileResolver
  const prepareTileData = (design, index) => {
    return {
      key: design.objectId || index,
      objectId: design.objectId,
      id: design.objectId,
      type: design.type || 'design',
      tileType: REGULAR_POST_TYPE,
      image: design.image,
      designThumbnail: design.designThumbnail,
      urlSlug: design.urlSlug,
      altText: design.altText,
      aiTitle: design.aiTitle,
      user: design.user,
      numLikes: design.numLikes,
      createdAt: design.createdAt,
      sourcePost: design,
      ...design
    }
  }

  return (
    <Container>
      <Title>
        <TitleText>More designs by </TitleText>
        <UserNameText>{userName}</UserNameText>
      </Title>
      <GridContainer>
        {displayedDesigns.map((design, index) => {
          const tileData = prepareTileData(design, index)

          return (
            <PostContainer key={design.objectId || index}>
              <PostTile>
                <FeedTileResolver tile={tileData} likesObj={likesObj} savedList={savedIds} lazyLoad={false} location="design-detail" />
              </PostTile>
            </PostContainer>
          )
        })}
      </GridContainer>
    </Container>
  )
}
